module.exports = {
  "wrap": {
    "position": "relative",
    "flexDirection": "row",
    "backgroundColor": "#ffffff"
  },
  "scroller": {
    "flex": 1,
    "alignContent": "center",
    "alignItems": "center",
    "backgroundColor": "rgba(0,0,0,0)",
    "overflow": "hidden"
  },
  "item-label": {
    "position": "absolute",
    "height": "81",
    "lineHeight": "81",
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "28",
    "color": "#8E969B",
    "textAlign": "left"
  },
  "list-item": {
    "height": "81",
    "lineHeight": "81",
    "fontFamily": "PingFangSC-Regular",
    "opacity": 0.3,
    "fontSize": "36",
    "color": "#1E2E37",
    "textAlign": "center"
  },
  "list-item-left": {
    "textAlign": "left"
  },
  "first-item": {
    "marginTop": "162"
  },
  "last-item": {
    "marginBottom": "162"
  },
  "first-visible-item": {
    "opacity": 0.15,
    "fontSize": "34",
    "backgroundColor": "#ffffff",
    "transform": "rotateX(60deg)"
  },
  "second-visible-item": {
    "opacity": 0.3,
    "fontSize": "34",
    "backgroundColor": "#ffffff",
    "transform": "rotateX(0deg)"
  },
  "second-last-visible-item": {
    "opacity": 0.3,
    "fontSize": "34",
    "backgroundColor": "#ffffff",
    "transform": "rotateX(0deg)"
  },
  "first-last-visible-item": {
    "opacity": 0.15,
    "fontSize": "34",
    "backgroundColor": "#ffffff",
    "transform": "rotateX(-60deg)"
  },
  "selected-item": {
    "opacity": 1,
    "color": "#1E2E37",
    "fontSize": "36"
  },
  "select-area": {
    "position": "absolute",
    "left": "0",
    "backgroundColor": "#EEEEEE"
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-ed05f3ee!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/dof-picker/picker.vue
// module id = 557
// module chunks = 0 1